<template>
    <div class="container">
        <v-title :breadcrumb="{label: 'Segments', route: {name: 'segments'}}">
            Segments
        </v-title>
        <v-form-tile>
            <h2 slot="title">Segments</h2>
            <div slot="description">
                <p class="text-muted stack-m">Segment are grids that allow the display and control over the data associated with you're Customers, Invoices, Transactions, Orders, or any Log information. Using Segments allows you to segment your data at a high level and quickly investigate the details to discover patterns, trends, and specifics as needed.</p>
                <p class="text-muted">Segments are organized into two main pages: Lists and Customer details. Lists are available from the sidebar, while customer details are available while viewing a specific customer.</p>
            </div>
            <div slot="content" class="tile">
                <div class="tile-content">
                    <div class="grid-fitted">
                        <div class="grid-item grid-item-full">
                            <div class="settings-item"
                                 v-push="{
                                    name: 'segment-management',
                                    params: {
                                        page: listsParams.page,
                                        category: listsParams.category,
                                    }
                                 }">
                                <div class="avatar avatar-description">
                                    <div class="avatar-image">
                                        <div class="avatar-icon">
                                            <v-icon icon="lists"/>
                                        </div>
                                    </div>
                                    <div class="avatar-info"><p>Lists</p>
                                        <p class="text-muted stack-m">Lists give you a neat and organized view of your account's data. Lists are organized into three main categories:  customers, commerce and logs. After that, the segments are presented in alphabetical order. You may also control the default visibility of each segment.</p>
                                        <p class="text-muted">For each segment, you can choose the filters, default columns and sort order that will be presented when you view it.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="grid-item grid-item-full">
                            <div class="settings-item"
                                 v-push="{
                                    name: 'segment-management',
                                    params: {
                                        page: customerDetailsParams.page,
                                        category: customerDetailsParams.category,
                                    }
                                 }">
                                <div class="avatar avatar-description">
                                    <div class="avatar-image">
                                        <div class="avatar-icon">
                                            <v-icon icon="customers"/>
                                        </div>
                                    </div>
                                    <div class="avatar-info"><p>Customer Details</p>
                                        <p class="text-muted stack-m">Customer Details give you a a neat and organized view to create segments for a customers data. Customer Details are organized into two main categories: commerce and logs. After that, the segments are presented in alphabetical order. You may also control the default visibility for each segment.</p>
                                        <p class="text-muted">For each segment, you can choose the filters, default columns and sort order that will be presented when you view it.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-form-tile>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vFormTile, vIcon} from '@/components/form';
    import SegmentDataModel from '@/common/models/segment-data-model';

    export default {
        name: 'segments',
        components: {
            vTitle, vIcon, vFormTile,
        },
        computed: {
            listsParams() {
                return {
                    page: SegmentDataModel.Pages.lists,
                    category: SegmentDataModel.Categories.customers,
                };
            },
            customerDetailsParams() {
                return {
                    page: SegmentDataModel.Pages.customerDetails,
                    category: SegmentDataModel.Categories.commerce,
                };
            },
        },
    };
</script>
